import React, { useContext, useEffect, useState } from 'react';
import { observer, useLocalStore } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { withErrorBoundary } from 'react-error-boundary';
import { CenteredLoadingSpinner, Table } from '@ole-ui/ole-ui-components';
import { handleError } from 'services/ErrorService';
import GenericViewError from 'components/Error/GenericViewError';
import { storesContext } from 'stores';
import UserMetricsEmptyState from '../EmptyState';
import LiveClassStatusTableStore from './store';

const LiveClassStatusTable = () => {
  const { t } = useTranslation();
  const { organizationStore, uiStore } = useContext(storesContext);
  const store = useLocalStore(
    () => new LiveClassStatusTableStore(organizationStore),
  );
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const controller = new AbortController();
    setIsLoading(true);
    const timer = setTimeout(async () => {
      try {
        await store.getReporteesLiveClassStatus(
          organizationStore.selectedUsersByManagerList,
          controller.signal,
        );
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    }, 1000);
    return () => {
      cancelled = true;
      clearTimeout(timer);
      controller.abort();
      setIsLoading(false);
    };
  }, [
    organizationStore.managerReportees,
    organizationStore.selectedUsersByManagerList,
  ]);

  useEffect(() => {
    store.versionTranslation = t('Version: ');
    store.userLiveClassTranslation = t('User name');
    store.liveClassStatusesTranslation = {
      scheduled: t('Scheduled'),
      attended: t('Attended'),
    };
  }, [uiStore.currentLanguage]);

  const renderEmptyState = () => (
    <UserMetricsEmptyState
      selectedCount={organizationStore.selectedUsersByManagerList?.length}
    />
  );

  if (isLoading) return <CenteredLoadingSpinner />;

  return (
    <div className="table-horiz-scroll mgmt-live-class-table">
      <Table
        ariaLabel={t('Live class status table')}
        columns={store.tableColumns}
        data={store.transformedData}
        variant="compact"
        renderEmptyState={renderEmptyState}
      />
    </div>
  );
};

export default withErrorBoundary(
  observer(LiveClassStatusTable),
  GenericViewError,
  handleError,
);
